import * as c from 'common/c'
import update from 'immutability-helper'
import { get, findIndex, cloneDeep } from 'es-toolkit/compat'

declare module 'state/farm.js' {
  export type FarmIntegrationData = {
    id: string
    clients: string
    fields: string
    self: string
    owningOrganization: string
    archived: boolean
  }
  export type FarmModel = {
    id: number
    name: string
    streetAddress?: string
    postalCode?: string
    email?: string
    clientId: number
    integrationIds: { [key: string]: FarmIntegrationData }
  }
  export type Farm = {
    collection: FarmModel[]
    singleton: FarmModel | undefined
    selectedFarms: []
  }
  export type FarmOptionModel = {
    id: number
    name: string
  }
}

const initialState = {
  collection: [],
  singleton: undefined,
  selectedFarms: [],
}

export default (state = initialState, action) => {
  switch (action.type) {
    case c.FARM_CREATED: {
      return update(state, {
        //@ts-expect-error
        collection: { $unshift: [action.payload] },
        singleton: { $set: action.payload },
      })
    }
    case c.FARMS_FETCHED: {
      return update(state, {
        collection: { $set: action.payload },
        singleton: { $set: action.payload[0] },
      })
    }

    // case c.FARM_PREFERENCES_FETCHED: {
    //   const preferences = action.payload
    //   return update(state, { prefs: { $set: preferences } })
    // }

    case c.FARMSETTINGS_EMPTY_ITEM_DELETED: {
      const column = action.payload
      const index = state[column].findIndex((p) => p.temp === true)
      return update(state, { [column]: { $splice: [[index, 1]] } })
    }

    case c.FARM_UPDATED: {
      const index = findIndex(
        get(state, 'collection', []),
        (farm: FarmModel) => farm.id === action.payload.id,
      )

      if (index > -1) {
        return update(state, {
          //@ts-expect-error
          collection: { $splice: [[index, 1, action.payload]] },
        })
      } else return
    }

    case c.FARMS_UPDATED: {
      const farms: FarmModel[] = cloneDeep(state.collection)

      action.payload.map((item) => {
        const index = findIndex(
          get(state, 'collection', []),
          (farm: FarmModel) => farm.id === item.id,
        )

        if (index > -1) {
          farms[index] = item
        }
      })
      //@ts-expect-error
      return update(state, { collection: { $set: farms } })
    }

    case c.FARM_DELETED: {
      const index = findIndex(
        get(state, 'collection', []),
        (farm: FarmModel) => farm.id === action.payload,
      )

      if (index > -1) {
        return update(state, {
          collection: { $splice: [[index, 1]] },
        })
      } else return state
    }

    case c.FARMS_DELETED: {
      const ids = action.payload
      const currentFarms: FarmModel[] = cloneDeep(state.collection)

      const final = currentFarms.filter((p) => !ids.includes(p.id))
      //@ts-expect-error
      return update(state, { collection: { $set: final } })
    }

    case c.FARMS_SELECTED: {
      const farmIds = action.payload
      return update(state, {
        selectedFarms: {
          $set: farmIds,
        },
      })
    }

    default:
      return state
  }
}
